<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">

	<div
		class="row"
		*ngIf="loading">
		<div class="col text-center">
			<app-loader [material]="false"></app-loader>
		</div>
	</div>

	<div
		class="row"
		*ngIf="!sections?.length && !loading">
		<div class="col text-center">Nessuna sezione aggiuntiva</div>
	</div>

	<div *ngIf="sections?.length && !loading">
		<div class="row">

			<div
				*ngFor="let section of sections;let index = index;trackBy:trackByIndex;"
				class="form-group col-md-12">
				<label>
					{{ section.title}}
					<span *ngIf="section.mandatory">*</span>
				</label>
				<quill-editor
					[required]="section.mandatory"
					name="description{{index}}"
					[(ngModel)]="section.wysiwyg"
					placeholder
					#textblockdata="ngModel"
					[ngClass]="editForm.submitted && textblockdata.invalid ? 'is-invalid' : ''">
				</quill-editor>
				<div
					class="invalid-feedback"
					*ngIf="editForm.submitted && textblockdata.invalid">
					{{'errors.required' | translate}}
				</div>
			</div>
		</div>

		<div class="modal-footer non-modal-footer">
			<button
				type="submit"
				class="btn btn-primary">
				{{'labels.save' | translate}}
			</button>
		</div>
	</div>
</form>
